import { updateDiagramShowColors, getDiagramShowColors } from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { Event } from '@process-advisor/process-miner/api/events';

export type ShowColorsProps  = ApiMethodBase & {
    visible?: boolean;
}

export const changeShowColors = ({
    visible,
    eventEmitter,
}: ShowColorsProps) => {
    updateDiagramShowColors({visible});
    eventEmitter.emit(Event.updateTimeInActivity);
}

export const getShowColors = (): ShowColorsProps => getDiagramShowColors();
